import React from 'react';
// import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { Trash2, Plus, Package, Calculator, MapPin, Weight, Shield } from 'lucide-react';
import { useMyContext } from '../../../../context/MyContext';
import axios from 'axios';
import Sidebar from '../../../../component/b2b/sideBar/b2bSideBar';
import NavBar from '../../../../component/b2b/navBar/b2bNavBar';
import '../../../../css/custom-scrollbar.css';
import { Base_Url, getB2bpIncode, b2bPriceEstimator } from '../../../../config/config';
import { toast } from 'react-toastify';
import B2BViewRateForward from '../../../../component/b2b/models/priceEstimatorModelB2b';

const B2bRateCalculator = () => {
    const { isDarkMode, isToggleSidebar, selectedCft } = useMyContext();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [formData, setFormData] = useState({
        originPincode: '',
        destinationPincode: '',
        insurance: 'Owner',
        totalWeight: '',
        cod_amount: '',
        totalBoxes: '',
        invoiceValue: '',
        paymentMode: '',
        pickupStatus: ''
    });

    const [boxes, setBoxes] = useState([]);
    const [originCity, setOriginCity] = useState('');
    const [destinationCity, setDestinationCity] = useState('');
    const [loading, setLoading] = useState(false);
    const [estimateData, setEstimateData] = useState([]);
    const [originODA, setOriginODA] = useState(null);
    const [destinationODA, setDestinationODA] = useState(null);

    const handleViewClick = () => {
        setIsPopupOpen(true);
    };

    const handleClose = () => {
        setIsPopupOpen(false);
    };


    // API function to fetch pincode data
    const fetchPincodeData = async (pincode, type) => {
        const token = localStorage.getItem("token");
        const cus_id = localStorage.getItem("cus_id");
        const urlgetPincode = `${Base_Url}${getB2bpIncode}?pincode=${pincode}`;
        try {
            const response = await fetch(urlgetPincode, {
                method: "GET",
                headers: {
                    token: token,
                    cus_id: cus_id,
                    "Content-Type": "application/json",
                },
            });
            const data = await response.json();
            if (data && data.status === "SUCCESS" && data.data) {
                // API returns object now
                let { city, state, oda } = data.data;

                // Capitalize
                city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
                state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();

                // Set city for origin or destination
                if (type === "origin") {
                    setOriginCity(city);
                    setOriginODA(oda);   // <--- NEW
                } else if (type === "destination") {
                    setDestinationCity(city);
                    setDestinationODA(oda);  // <--- NEW
                }
                return { city, state, oda, success: true };
            }
            else if (data && data.message === "Unauthorized access - Invalid token") {
                toast.error(data.message + " Please login Again");
                return { success: false, error: "unauthorized" };
            }
            else {
                toast.error("Failed to fetch pincode details");
                return { success: false, error: "failed" };
            }
        } catch (error) {
            console.error("Error fetching pincode data:", error);
            toast.error("Error fetching pincode data");
            return { success: false, error: "network" };
        }
    };

    const handleInputChange = async (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));

        // Origin pincode
        if (field === 'originPincode') {

            // reset origin & destination ODA when typing
            setOriginODA(null);

            if (value.length === 6) {
                setLoading(true);
                await fetchPincodeData(value, 'origin');
                setLoading(false);
            } else {
                setOriginCity('');
            }
        }

        // Destination pincode
        if (field === 'destinationPincode') {

            // reset destination ODA when typing
            setDestinationODA(null);

            if (value.length === 6) {
                setLoading(true);
                await fetchPincodeData(value, 'destination');
                setLoading(false);
            } else {
                setDestinationCity('');
            }
        }
    };

    const addBoxSet = () => {
        const totalBoxesUsed = boxes.reduce((sum, box) => sum + parseInt(box.quantity || 0), 0);
        const remainingBoxes = parseInt(formData.totalBoxes || 0) - totalBoxesUsed;

        if (remainingBoxes > 0) {
            setBoxes(prev => [...prev, {
                id: Date.now(),
                quantity: '',
                length: '',
                width: '',
                height: ''
            }]);
        }
    };

    const removeBoxSet = (id) => {
        setBoxes(prev => prev.filter(box => box.id !== id));
    };

    // const updateBoxSet = (id, field, value) => {
    //     setBoxes(prev => prev.map(box =>
    //         box.id === id ? { ...box, [field]: value } : box
    //     ));
    // };

    const updateBoxSet = (id, field, value) => {
        setBoxes(prev => prev.map(box => {
            if (box.id === id) {
                if (field === 'quantity') {
                    const newQuantity = parseInt(value || 0);
                    const totalBoxes = parseInt(formData.totalBoxes || 0);

                    const otherBoxesUsed = prev
                        .filter(b => b.id !== id)
                        .reduce((sum, b) => sum + parseInt(b.quantity || 0), 0);

                    const maxAllowed = totalBoxes - otherBoxesUsed;

                    // Automatically cap the value to the maximum allowed
                    const cappedQuantity = Math.min(newQuantity, maxAllowed);
                    return { ...box, [field]: cappedQuantity.toString() };
                }

                return { ...box, [field]: value };
            }
            return box;
        }));
    };

    const getTotalBoxesUsed = () => {
        return boxes.reduce((sum, box) => sum + parseInt(box.quantity || 0), 0);
    };

    const getRemainingBoxes = () => {
        return parseInt(formData.totalBoxes || 0) - getTotalBoxesUsed();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        for (const box of boxes) {
            if (
                !box.length ||
                !box.width ||
                !box.height ||
                box.length === "" ||
                box.width === "" ||
                box.height === ""
            ) {
                toast.error("Please enter Length, Width, and Height for all boxes.");
                return; // stop execution
            }
        }
        const payload = {
            retailer_id: parseInt(localStorage.getItem("cus_id")),
            origin_pincode: formData.originPincode,
            destination_pincode: formData.destinationPincode,
            insorance: formData.insurance,
            weight: parseFloat(formData.totalWeight),
            payment_Mode: formData.paymentMode,
            pickup_status: formData.pickupStatus,
            cft: selectedCft,
            invoice_value: parseFloat(formData.invoiceValue || 0),
            dimensions: boxes.map((box) => ({
                quantity: parseInt(box.quantity),
                total_length: parseFloat(box.length),
                total_width: parseFloat(box.width),
                total_height: parseFloat(box.height),
            })),
        };

        try {
            const token = localStorage.getItem("token");
            const cus_id = localStorage.getItem("cus_id");
            const response = await axios.post(
                Base_Url + b2bPriceEstimator, // 👈 API endpoint
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        token: token, // 👈 if API expects Bearer token
                        cus_id: cus_id, // 👈 custom header for customer id
                    },
                }
            );

            if (response.data.status === "success") {
                toast.success(response.data.message);
                setEstimateData(response.data);
                handleViewClick();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error("Something went wrong while fetching rates");
            if (error.response?.data?.messages) {
                const messages = error.response.data.messages;

                // Show each error message as a toast
                Object.values(messages).forEach((msg) => {
                    toast.error(msg);
                });
            } else if (error.response?.data?.message) {
                // Fallback to single error message
                toast.error(error.response.data.message);
            } else {
                // Generic error fallback
                toast.error("Something went wrong while fetching rates");
            }
        } finally {
            setLoading(false);
        }
    };

     const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

    return (
        <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-gray-50'}`}>
             <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />
                
                      <NavBar />
                
                      <div className="flex flex-1 overflow-hidden">
                
                        {isToggleSidebar && (
                          <div className={`w-64 m-3 rounded-3xl ${glass} overflow-hidden`}>
                            <Sidebar />
                          </div>
                        )}

                {/* Page body: fixed, never scrolls. Only the two inner panels scroll. */}
                <div className="flex-1 min-h-0 overflow-hidden bg-gray-200 p-2 md:p-3">
                    <div className="grid lg:grid-cols-3 gap-2 md:gap-3 h-full">

                        {/* Main Form Panel — scrolls internally */}
                        <div className="lg:col-span-2 h-full overflow-hidden">
                            <div className={`${isDarkMode ? 'bg-black' : 'bg-white border-gray-200'} h-full rounded-lg shadow-sm border flex flex-col overflow-hidden`}>

                                {/* Panel header */}
                                <div className={`shrink-0 px-3 py-1.5 border-b ${isDarkMode ? 'border-white/10' : 'border-gray-100'} flex items-center gap-2`}>
                                    <div className="w-5 h-5 rounded-md bg-black flex items-center justify-center shrink-0">
                                        <Calculator className="w-3 h-3 text-white" />
                                    </div>
                                    <h2 className={`text-[11px] font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                        Rate Calculator
                                    </h2>
                                </div>

                                {/* Scrollable form body */}
                                <div className="flex-1 overflow-y-auto custom-scrollbar px-3 py-2">
                                    <form onSubmit={handleSubmit} className="space-y-2.5">
                                        {/* Pincode Section */}
                                        <div className="space-y-1.5">
                                            <div className="flex items-center space-x-1">
                                                <MapPin className={`w-3 h-3 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`} />
                                                <h3 className={`text-[9px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                                                    Pickup & Delivery
                                                </h3>
                                            </div>
                                            <div className="grid md:grid-cols-2 gap-2">
                                                <div className="space-y-0.5">
                                                    <label className={`block text-[9px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                                        Origin Pincode *
                                                    </label>
                                                    <input
                                                        type="text"
                                                        maxLength="6"
                                                        value={formData.originPincode}
                                                        onChange={(e) => handleInputChange('originPincode', e.target.value.replace(/[^0-9]/g, ''))}
                                                        className={`w-full px-2 py-1 text-[10px] rounded border transition-all duration-200 ${isDarkMode
                                                            ? 'bg-gray-800 border-gray-700 text-white focus:border-gray-400'
                                                            : 'bg-gray-50 border-gray-200 text-gray-900 focus:border-black'
                                                            } focus:outline-none focus:ring-1 focus:ring-black`}
                                                        placeholder="Enter 6-digit pincode"
                                                        disabled={loading}
                                                    />
                                                    {loading && formData.originPincode.length === 6 && (
                                                        <p className={`text-[8px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                            🔄 Fetching...
                                                        </p>
                                                    )}
                                                    {originCity && (
                                                        <p className={`text-[8px] ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                                            📍 {originCity}
                                                        </p>
                                                    )}
                                                    {originODA == 1 && (
                                                        <p className="text-[8px] text-red-500">
                                                            ⚠️ ODA pincode
                                                        </p>
                                                    )}
                                                </div>

                                                <div className="space-y-0.5">
                                                    <label className={`block text-[9px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                                        Destination Pincode *
                                                    </label>
                                                    <input
                                                        type="text"
                                                        maxLength="6"
                                                        value={formData.destinationPincode}
                                                        onChange={(e) => handleInputChange('destinationPincode', e.target.value.replace(/[^0-9]/g, ''))}
                                                        className={`w-full px-2 py-1 text-[10px] rounded border transition-all duration-200 ${isDarkMode
                                                            ? 'bg-gray-800 border-gray-700 text-white focus:border-gray-400'
                                                            : 'bg-gray-50 border-gray-200 text-gray-900 focus:border-black'
                                                            } focus:outline-none focus:ring-1 focus:ring-black`}
                                                        placeholder="Enter 6-digit pincode"
                                                        disabled={loading}
                                                    />
                                                    {loading && formData.destinationPincode.length === 6 && (
                                                        <p className={`text-[8px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                            🔄 Fetching...
                                                        </p>
                                                    )}
                                                    {destinationCity && (
                                                        <p className={`text-[8px] ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                                            📍 {destinationCity}
                                                        </p>
                                                    )}
                                                    {destinationODA == 1 && (
                                                        <p className="text-[8px] text-red-500">
                                                            ⚠️ ODA pincode
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Insurance Section */}
                                        <div className="space-y-1.5">
                                            <div className="flex items-center space-x-1">
                                                <Shield className={`w-3 h-3 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`} />
                                                <h3 className={`text-[9px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                                                    Insurance Options
                                                </h3>
                                            </div>

                                            <div className="grid md:grid-cols-2 gap-1.5">
                                                <label className={`relative flex items-center p-1.5 rounded border cursor-pointer transition-all duration-200 ${formData.insurance === 'Owner'
                                                    ? isDarkMode ? 'border-gray-400 bg-gray-800' : 'border-black bg-gray-100'
                                                    : isDarkMode ? 'border-gray-700 bg-gray-800' : 'border-gray-200 bg-gray-50'
                                                    }`}>
                                                    <input
                                                        type="radio"
                                                        name="insurance"
                                                        value="Owner"
                                                        checked={formData.insurance === 'Owner'}
                                                        onChange={(e) => handleInputChange('insurance', e.target.value)}
                                                        className="sr-only"
                                                    />
                                                    <div className={`w-2.5 h-2.5 rounded-full border mr-1.5 flex items-center justify-center shrink-0 ${formData.insurance === 'Owner'
                                                        ? 'border-black'
                                                        : isDarkMode ? 'border-gray-400' : 'border-gray-400'
                                                        }`}>
                                                        {formData.insurance === 'Owner' && (
                                                            <div className="w-1.5 h-1.5 bg-black rounded-full"></div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <span className={`text-[10px] font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                            Owner Risk
                                                        </span>
                                                        <p className={`text-[8px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                            Customer bears risk
                                                        </p>
                                                    </div>
                                                </label>

                                                <label className={`relative flex items-center p-1.5 rounded border cursor-pointer transition-all duration-200 ${formData.insurance === 'Carrier'
                                                    ? isDarkMode ? 'border-gray-400 bg-gray-800' : 'border-black bg-gray-100'
                                                    : isDarkMode ? 'border-gray-700 bg-gray-800' : 'border-gray-200 bg-gray-50'
                                                    }`}>
                                                    <input
                                                        type="radio"
                                                        name="insurance"
                                                        value="Carrier"
                                                        checked={formData.insurance === 'Carrier'}
                                                        onChange={(e) => handleInputChange('insurance', e.target.value)}
                                                        className="sr-only"
                                                    />
                                                    <div className={`w-2.5 h-2.5 rounded-full border mr-1.5 flex items-center justify-center shrink-0 ${formData.insurance === 'Carrier'
                                                        ? 'border-black'
                                                        : isDarkMode ? 'border-gray-400' : 'border-gray-400'
                                                        }`}>
                                                        {formData.insurance === 'Carrier' && (
                                                            <div className="w-1.5 h-1.5 bg-black rounded-full"></div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <span className={`text-[10px] font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                            Carrier Risk
                                                        </span>
                                                        <p className={`text-[8px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                            Carrier bears risk
                                                        </p>
                                                    </div>
                                                </label>
                                            </div>
                                        </div>

                                        {/* Weight and Boxes Section */}
                                        <div className="space-y-1.5">
                                            <div className="flex items-center space-x-1">
                                                <Weight className={`w-3 h-3 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`} />
                                                <h3 className={`text-[9px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                                                    Weight & Package Details
                                                </h3>
                                            </div>

                                            <div className="grid md:grid-cols-3 gap-1.5">
                                                <div className="space-y-0.5">
                                                    <label className={`block text-[9px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                                        Total Weight (kg) *
                                                    </label>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        value={formData.totalWeight}
                                                        onChange={(e) => handleInputChange('totalWeight', e.target.value)}
                                                        className={`w-full px-2 py-1 text-[10px] rounded border transition-all duration-200 ${isDarkMode
                                                            ? 'bg-gray-800 border-gray-700 text-white focus:border-gray-400'
                                                            : 'bg-gray-50 border-gray-200 text-gray-900 focus:border-black'
                                                            } focus:outline-none focus:ring-1 focus:ring-black`}
                                                        placeholder="Enter weight"
                                                    />
                                                </div>

                                                <div className="space-y-0.5">
                                                    <label className={`block text-[9px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                                        Total Boxes *
                                                    </label>
                                                    <input
                                                        type="number"
                                                        min="1"
                                                        value={formData.totalBoxes}
                                                        onChange={(e) => handleInputChange('totalBoxes', e.target.value)}
                                                        className={`w-full px-2 py-1 text-[10px] rounded border transition-all duration-200 ${isDarkMode
                                                            ? 'bg-gray-800 border-gray-700 text-white focus:border-gray-400'
                                                            : 'bg-gray-50 border-gray-200 text-gray-900 focus:border-black'
                                                            } focus:outline-none focus:ring-1 focus:ring-black`}
                                                        placeholder="Number of boxes"
                                                    />
                                                </div>

                                                <div className="space-y-0.5">
                                                    <label className={`block text-[9px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                                        Invoice Value
                                                    </label>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        value={formData.invoiceValue}
                                                        onChange={(e) => handleInputChange('invoiceValue', e.target.value)}
                                                        className={`w-full px-2 py-1 text-[10px] rounded border transition-all duration-200 ${isDarkMode
                                                            ? 'bg-gray-800 border-gray-700 text-white focus:border-gray-400'
                                                            : 'bg-gray-50 border-gray-200 text-gray-900 focus:border-black'
                                                            } focus:outline-none focus:ring-1 focus:ring-black`}
                                                        placeholder="Declared value"
                                                    />
                                                </div>
                                                <div className="space-y-0.5">
                                                    <label
                                                        className={`block text-[9px] font-medium ${isDarkMode ? "text-gray-400" : "text-gray-600"
                                                            }`}
                                                    >
                                                        Payment Mode
                                                    </label>

                                                    <select
                                                        value={formData.paymentMode}
                                                        onChange={(e) => handleInputChange("paymentMode", e.target.value)}
                                                        className={`w-full px-2 py-1 text-[10px] rounded border transition-all duration-200 ${isDarkMode
                                                            ? "bg-gray-800 border-gray-700 text-white focus:border-gray-400"
                                                            : "bg-gray-50 border-gray-200 text-gray-900 focus:border-black"
                                                            } focus:outline-none focus:ring-1 focus:ring-black`}
                                                    >
                                                        <option value="">Select Payment</option>
                                                        <option value="prepaid">Prepaid</option>
                                                        <option value="cod">COD</option>
                                                    </select>
                                                </div>

                                                {
                                                    formData.paymentMode === 'cod' ?
                                                        <div className="space-y-0.5">
                                                            <label className={`block text-[9px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                                                COD Amount *
                                                            </label>
                                                            <input
                                                                type="number"
                                                                min="1"
                                                                value={formData.cod_amount}
                                                                onChange={(e) => handleInputChange('cod_amount', e.target.value)}
                                                                className={`w-full px-2 py-1 text-[10px] rounded border transition-all duration-200 ${isDarkMode
                                                                    ? 'bg-gray-800 border-gray-700 text-white focus:border-gray-400'
                                                                    : 'bg-gray-50 border-gray-200 text-gray-900 focus:border-black'
                                                                    } focus:outline-none focus:ring-1 focus:ring-black`}
                                                                placeholder="COD Amount"
                                                            />
                                                        </div>
                                                        : ""
                                                }



                                                <div className="space-y-0.5">
                                                    <label
                                                        className={`block text-[9px] font-medium ${isDarkMode ? "text-gray-400" : "text-gray-600"
                                                            }`}
                                                    >
                                                        Pickup Arrangement
                                                    </label>

                                                    <select
                                                        value={formData.pickupStatus}
                                                        onChange={(e) => handleInputChange("pickupStatus", e.target.value)}
                                                        className={`w-full px-2 py-1 text-[10px] rounded border transition-all duration-200 ${isDarkMode
                                                            ? "bg-gray-800 border-gray-700 text-white focus:border-gray-400"
                                                            : "bg-gray-50 border-gray-200 text-gray-900 focus:border-black"
                                                            } focus:outline-none focus:ring-1 focus:ring-black`}
                                                    >
                                                        <option value="">Select Pickup</option>
                                                        <option value="fmpickup">FM Pickup</option>
                                                        <option value="selfdrop">Self Drop</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Box Sets Section */}
                                        <div className="space-y-1.5">
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center space-x-1">
                                                    <Package className={`w-3 h-3 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`} />
                                                    <h3 className={`text-[9px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                                                        Box Dimensions
                                                    </h3>
                                                </div>

                                                {formData.totalBoxes && getRemainingBoxes() > 0 && (
                                                    <button
                                                        type="button"
                                                        onClick={addBoxSet}
                                                        className="flex items-center space-x-0.5 px-1.5 py-0.5 bg-black text-white text-[9px] rounded hover:bg-gray-800 transition-all duration-200"
                                                    >
                                                        <Plus className="w-2.5 h-2.5" />
                                                        <span>Add Box</span>
                                                    </button>
                                                )}
                                            </div>

                                            {formData.totalBoxes && (
                                                <div className={`p-1.5 rounded ${isDarkMode ? 'bg-gray-800' : 'bg-gray-50'} border ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                                                    <div className="flex justify-between items-center">
                                                        <span className={`text-[9px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                                            Total: {formData.totalBoxes}
                                                        </span>
                                                        <span className={`text-[9px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                                            Used: {getTotalBoxesUsed()} | Remaining: {getRemainingBoxes()}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Box Sets */}
                                            <div className="space-y-1.5">
                                                {boxes.map((box, index) => (
                                                    <div key={box.id} className={`p-2 rounded border transition-all duration-200 ${isDarkMode
                                                        ? 'bg-gray-800 border-gray-700 hover:border-gray-600'
                                                        : 'bg-gray-50 border-gray-200 hover:border-gray-300'
                                                        }`}>
                                                        <div className="flex items-center justify-between mb-1.5">
                                                            <h4 className={`text-[9px] font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                                Box Set {index + 1}
                                                            </h4>
                                                            <button
                                                                type="button"
                                                                onClick={() => removeBoxSet(box.id)}
                                                                className="p-0.5 text-red-500 hover:bg-red-500 hover:text-white rounded transition-all duration-200"
                                                            >
                                                                <Trash2 className="w-2.5 h-2.5" />
                                                            </button>
                                                        </div>

                                                        <div className="grid grid-cols-2 md:grid-cols-4 gap-1.5">
                                                            <div className="space-y-0.5">
                                                                <label className={`block text-[8px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                                                    Qty *
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    min="1"
                                                                    max={getRemainingBoxes() + parseInt(box.quantity || 0)}
                                                                    value={box.quantity}
                                                                    onChange={(e) => updateBoxSet(box.id, 'quantity', e.target.value)}
                                                                    className={`w-full px-1.5 py-0.5 text-[9px] rounded border transition-all duration-200 ${isDarkMode
                                                                        ? 'bg-gray-700 border-gray-600 text-white'
                                                                        : 'bg-white border-gray-300 text-gray-900'
                                                                        } focus:outline-none focus:ring-1 focus:ring-black`}
                                                                    placeholder="Qty"
                                                                />
                                                            </div>

                                                            <div className="space-y-0.5">
                                                                <label className={`block text-[8px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                                                    Length (cm) *
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    step="0.01"
                                                                    value={box.length}
                                                                    onChange={(e) => updateBoxSet(box.id, 'length', e.target.value)}
                                                                    className={`w-full px-1.5 py-0.5 text-[9px] rounded border transition-all duration-200 ${isDarkMode
                                                                        ? 'bg-gray-700 border-gray-600 text-white'
                                                                        : 'bg-white border-gray-300 text-gray-900'
                                                                        } focus:outline-none focus:ring-1 focus:ring-black`}
                                                                    placeholder="L"
                                                                />
                                                            </div>

                                                            <div className="space-y-0.5">
                                                                <label className={`block text-[8px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                                                    Width (cm) *
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    step="0.01"
                                                                    value={box.width}
                                                                    onChange={(e) => updateBoxSet(box.id, 'width', e.target.value)}
                                                                    className={`w-full px-1.5 py-0.5 text-[9px] rounded border transition-all duration-200 ${isDarkMode
                                                                        ? 'bg-gray-700 border-gray-600 text-white'
                                                                        : 'bg-white border-gray-300 text-gray-900'
                                                                        } focus:outline-none focus:ring-1 focus:ring-black`}
                                                                    placeholder="W"
                                                                />
                                                            </div>

                                                            <div className="space-y-0.5">
                                                                <label className={`block text-[8px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                                                    Height (cm) *
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    step="0.01"
                                                                    value={box.height}
                                                                    onChange={(e) => updateBoxSet(box.id, 'height', e.target.value)}
                                                                    className={`w-full px-1.5 py-0.5 text-[9px] rounded border transition-all duration-200 ${isDarkMode
                                                                        ? 'bg-gray-700 border-gray-600 text-white'
                                                                        : 'bg-white border-gray-300 text-gray-900'
                                                                        } focus:outline-none focus:ring-1 focus:ring-black`}
                                                                    placeholder="H"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                {/* Sticky submit footer */}
                                <div className={`shrink-0 px-3 py-2 border-t ${isDarkMode ? 'border-white/10' : 'border-gray-100'}`}>
                                    <button
                                        type="button"
                                        onClick={handleSubmit}
                                        disabled={loading || !formData.originPincode || !formData.destinationPincode || !formData.totalWeight || !formData.totalBoxes || getTotalBoxesUsed() !== parseInt(formData.totalBoxes || 0)}
                                        className={`w-full py-1.5 px-3 rounded text-[10px] font-semibold transition-all duration-200 ${loading || !formData.originPincode || !formData.destinationPincode || !formData.totalWeight || !formData.totalBoxes || getTotalBoxesUsed() !== parseInt(formData.totalBoxes || 0)
                                            ? 'bg-gray-400 cursor-not-allowed'
                                            : 'bg-black hover:bg-gray-800 shadow-sm hover:shadow-md'
                                            } text-white`}
                                    >
                                        {loading ? (
                                            <div className="flex items-center justify-center space-x-1.5">
                                                <div className="w-2.5 h-2.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                                <span>Calculating...</span>
                                            </div>
                                        ) : (
                                            <div className="flex items-center justify-center space-x-1.5">
                                                <Calculator className="w-2.5 h-2.5" />
                                                <span>Calculate Rate</span>
                                            </div>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Sidebar Panel — scrolls internally */}
                        <div className="h-full overflow-hidden">
                            <div className={`${isDarkMode ? 'bg-black' : 'bg-white border-gray-200'} h-full rounded-lg shadow-sm border overflow-y-auto custom-scrollbar p-2.5 space-y-2.5`}>

                                {/* Summary Card */}
                                <div>
                                    <h3 className={`text-[9px] font-semibold uppercase tracking-wide mb-1.5 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                                        Shipment Summary
                                    </h3>

                                    <div className="space-y-1">
                                        <div className="flex justify-between">
                                            <span className={`text-[9px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Origin:</span>
                                            <span className={`text-[9px] font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                {originCity || 'Not set'}
                                            </span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className={`text-[9px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Destination:</span>
                                            <span className={`text-[9px] font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                {destinationCity || 'Not set'}
                                            </span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className={`text-[9px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Weight:</span>
                                            <span className={`text-[9px] font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                {formData.totalWeight ? `${formData.totalWeight} kg` : 'Not set'}
                                            </span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className={`text-[9px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Boxes:</span>
                                            <span className={`text-[9px] font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                {formData.totalBoxes || 'Not set'}
                                            </span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className={`text-[9px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Insurance:</span>
                                            <span className={`text-[9px] font-medium capitalize ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                {formData.insurance}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Box Details Card */}
                                {boxes.length > 0 && (
                                    <div className={`pt-2 border-t ${isDarkMode ? 'border-white/10' : 'border-gray-100'}`}>
                                        <h3 className={`text-[9px] font-semibold uppercase tracking-wide mb-1.5 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                                            Box Details
                                        </h3>

                                        <div className="space-y-1">
                                            {boxes.map((box, index) => (
                                                <div key={box.id} className={`p-1.5 rounded ${isDarkMode ? 'bg-gray-800' : 'bg-gray-50'}`}>
                                                    <div className="flex justify-between items-center mb-0.5">
                                                        <span className={`text-[9px] font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                                            Set {index + 1}
                                                        </span>
                                                        <span className={`text-[8px] px-1 py-0.5 rounded-full ${isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'}`}>
                                                            {box.quantity || 0} boxes
                                                        </span>
                                                    </div>
                                                    <div className={`text-[8px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                        {box.length || 0} × {box.width || 0} × {box.height || 0} cm
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/* Instructions Card */}
                                <div className={`pt-2 border-t ${isDarkMode ? 'border-white/10' : 'border-gray-100'}`}>
                                    <h3 className={`text-[9px] font-semibold uppercase tracking-wide mb-1.5 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                                        How to Use
                                    </h3>

                                    <div className="space-y-1">
                                        <div className={`flex items-start space-x-1.5 ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
                                            <span className="flex-shrink-0 w-3.5 h-3.5 bg-black text-white text-[8px] rounded-full flex items-center justify-center mt-0.5">
                                                1
                                            </span>
                                            <span className="text-[9px]">Enter origin & destination pincodes</span>
                                        </div>
                                        <div className={`flex items-start space-x-1.5 ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
                                            <span className="flex-shrink-0 w-3.5 h-3.5 bg-black text-white text-[8px] rounded-full flex items-center justify-center mt-0.5">
                                                2
                                            </span>
                                            <span className="text-[9px]">Select insurance & package details</span>
                                        </div>
                                        <div className={`flex items-start space-x-1.5 ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
                                            <span className="flex-shrink-0 w-3.5 h-3.5 bg-black text-white text-[8px] rounded-full flex items-center justify-center mt-0.5">
                                                3
                                            </span>
                                            <span className="text-[9px]">Add box dimensions for each type</span>
                                        </div>
                                        <div className={`flex items-start space-x-1.5 ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
                                            <span className="flex-shrink-0 w-3.5 h-3.5 bg-black text-white text-[8px] rounded-full flex items-center justify-center mt-0.5">
                                                4
                                            </span>
                                            <span className="text-[9px]">Click calculate to get rate</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <B2BViewRateForward
                isopen={isPopupOpen}
                onClose={handleClose}
                data={estimateData}
                type="checkRates"
            />
        </div>
    );
};

export default B2bRateCalculator;